import { lang } from '@umu/ukit-lang';

export const getDefaultState: IState = {
    lastName: '', // 姓
    firstName: '', // 名
    phone: '', // 手机
    email: '', // 邮箱
    enterpriseName: '', //  企业名称
    positionName: null, // 职位
    description: '', // 留言
    department: '',
    staffCount: null,
    areaCode: '',
    codePosition: '',
    showLastName: false,
    showFirstName: false,
    showPhoneMsg: false,
    showMailMsg: false,
    showMailMsgExt: false,
    showEnterpriseName: false,
    showPositionName: false,
    howHearAboutUs: null,
    receiveSubscribe: true,
};

export const amountOptionList = [
    '< 50',
    '50 - 99',
    '100 - 499',
    '500 - 999',
    '1000 - 4999',
    '5000 - 9999',
    '> 10000',
].map((item) => ({
    label: item,
    id: item,
}));

export const staffCountOptionList = [
    '1-10',
    '11-50',
    '51-200',
    '201-500',
    '501 - 1000',
    '1001 - 2000',
    '2001 - 3000',
    '3001 - 4000',
    '4001 - 5000',
    '5000 - 10000',
    '10000 +',
].map((item) => ({
    label: item,
    id: item,
}));

export const howHearAboutUsOptionsList = ['Youtube', 'LinkedIn', lang('邮件'), lang('他人推荐'), lang('其他途径')].map(
    (item) => ({
        label: item,
        id: item,
    }),
);

export const excludeEmailExt = [
    '@gmail',
    '@hotmail',
    '@yahoo',
    '@live',
    '@outlook',
    '@aol',
    '@msn',
    '@comcast',
    '@mail',
    '@yandex',
];
